import React, { useEffect } from 'react';
import { useAdornmentState } from './context';
import { CustomAdornment } from './shared';
import { useAdornmentVariants } from './variants';
const useAdornmentConfig = ({ variant, options, }) => {
    const adornments = useAdornmentVariants((options === null || options === void 0 ? void 0 : options.variant) !== 'custom' ? options : {});
    if (!variant && !options)
        return {};
    // Condition 1:
    // this is true if a string representing a built-in variant is passed as
    // a `variant` param
    if (variant)
        return adornments[variant];
    // Condition 2:
    // this condition is true when an `options` object is passed for
    // a built-in variant and `variant` does not equal 'custom'
    const isBuiltInCustom = options.variant && (options === null || options === void 0 ? void 0 : options.variant) !== 'custom';
    if (isBuiltInCustom) {
        const { variant: optsVariant, position } = options;
        const config = adornments[optsVariant];
        return Object.assign(Object.assign({}, config), (position ? { position } : {}));
    }
    // if neither condition 1 nor condition 2 are true, then typings have ensured
    // that an `options` object for a non-built-in variant is being passed
    return Object.assign({}, options);
};
export const Adornment = ({ variant, options, inputValue, children, }) => {
    const config = useAdornmentConfig({ variant, options });
    const item = config.item || {};
    const position = config.position || 'right';
    const { setPosition, setInputValue } = useAdornmentState();
    const isVariant = !!(variant || options);
    useEffect(() => {
        if (isVariant) {
            setPosition(position || 'right');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variant, position]);
    useEffect(() => {
        if (isVariant) {
            setInputValue(inputValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variant, inputValue]);
    if (!isVariant) {
        return React.createElement(React.Fragment, null, children);
    }
    const leftAligned = (React.createElement(React.Fragment, null,
        React.createElement(CustomAdornment, Object.assign({}, item, { ref: item.ref
                ? item.ref
                : undefined })),
        children));
    const rightAligned = (React.createElement(React.Fragment, null,
        children,
        React.createElement(CustomAdornment, Object.assign({}, item))));
    switch (position) {
        case 'left':
            return leftAligned;
        case 'right':
            return rightAligned;
        default:
            return rightAligned;
    }
};
//# sourceMappingURL=Adornment.js.map